
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { Control } from "@/oxygen/classes/lib/types";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

@Component({
  components: {
    TextInput
  }
})
export default class OxygenUnitInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input", { type: String })
  syncedValue?: string;
}
